// Komt dit (toets)event uit een CDK-overlay (dialoog, autocomplete-panel, menu, select-panel)? Overlays
// hangen in .cdk-overlay-container onder <body>, dus hun keydown bubbelt door naar document-listeners van
// de pagina (bv. Esc in _SectionFormComponent: formulier terugzetten / pageMode wisselen). Zo'n Esc hoort
// bij de overlay (die sluit zichzelf); de pagina moet hem negeren.
export function eventFromOverlay(event: Event): boolean {
    const __target = event.target;
    return __target instanceof Element && !!__target.closest('.cdk-overlay-container');
}
